"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubRowSelection = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const useSubRowSelection = (hooks) => {
    hooks.useInstance.push(useInstance);
};
exports.useSubRowSelection = useSubRowSelection;
const useInstance = (instance) => {
    const selectedFlatRows = React.useMemo(() => {
        const selectedFlatRows = [];
        const setSelectionState = (row, selectedRowIds) => {
            let isSomeSubRowsSelected = false;
            row.subRows.forEach((subRow) => {
                setSelectionState(subRow, selectedRowIds);
                if (subRow.isSelected || subRow.isSomeSelected) {
                    isSomeSubRowsSelected = true;
                }
            });
            if (selectedRowIds[row.id]) {
                row.isSelected = true;
                row.isSomeSelected = false;
                selectedFlatRows.push(row);
            }
            else {
                row.isSelected = false;
                row.isSomeSelected = isSomeSubRowsSelected;
            }
        };
        instance.rows.forEach((row) => setSelectionState(row, instance.state.selectedRowIds));
        return selectedFlatRows;
    }, [instance.rows, instance.state.selectedRowIds]);
    Object.assign(instance, {
        selectedFlatRows,
    });
};
